export interface LoginRequest {
  username: string;
  password: string;
  device_id: string;
  // hcaptcha_token?: string; // Temporarily disabled.
}

export interface LoginResponse {
  refresh: string;
  access: string;
}

export type LoginAttemptStatus = "error" | "warning" | "blocked";

export interface LoginErrorResponse {
  detail?: string;
  status?: LoginAttemptStatus | string;
  attempts_left?: string | number | null;
}

export interface LoginFailure {
  status: LoginAttemptStatus;
  detail: string;
  attemptsLeft?: number;
}

export class LoginFailureError extends Error implements LoginFailure {
  status: LoginAttemptStatus;

  detail: string;

  attemptsLeft?: number;

  constructor({ status, detail, attemptsLeft }: LoginFailure) {
    super(detail);
    this.name = "LoginFailureError";
    this.status = status;
    this.detail = detail;
    this.attemptsLeft = attemptsLeft;
  }
}

export const isLoginFailure = (value: unknown): value is LoginFailureError =>
  value instanceof LoginFailureError;

export interface RefreshTokenRequest {
  refresh: string;
}

export interface RefreshTokenResponse {
  refresh?: string; // Refresh token is optional - backend might not return a new one
  access: string;
}

export interface LogoutResponse {
  detail: string;
}

export type AccountType =
  | "SUPER_ADMIN"
  | "ADMIN"
  | "USER"
  | "END_USER"
  | "STAFF"
  | "SYSTEM_ADMIN";

export interface UserProfile {
  id: number;
  phone: string | null;
  email: string | null;
  full_name: string | null;
  avatar: string | null;
  permissions: string;
  account_type: AccountType;
  role: {
    id: number;
    name: string;
    access_level: string;
  } | null;
  region: {
    id: number;
    name: string;
  } | null;
  city: {
    id: number;
    name: string;
  } | null;
  makhalla: {
    id: number;
    name: string;
  } | null;
}
